import { render, staticRenderFns } from "./RahoitettavanYhteenveto.vue?vue&type=template&id=820e1d0e&"
import script from "./RahoitettavanYhteenveto.vue?vue&type=script&lang=js&"
export * from "./RahoitettavanYhteenveto.vue?vue&type=script&lang=js&"
import style0 from "./RahoitettavanYhteenveto.vue?vue&type=style&index=0&id=820e1d0e&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('820e1d0e')) {
      api.createRecord('820e1d0e', component.options)
    } else {
      api.reload('820e1d0e', component.options)
    }
    module.hot.accept("./RahoitettavanYhteenveto.vue?vue&type=template&id=820e1d0e&", function () {
      api.rerender('820e1d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RahoitettavanYhteenveto.vue"
export default component.exports